import { DeliveryResolver } from "./DeliveryResolver";
import { milkmanStore } from "../../store/milkmanStore";
import _ from 'lodash'
const moment = require('moment')

export class MilkmanDeliveryResolver extends DeliveryResolver {
  timeRangeEnabled = true;
  store = milkmanStore;
  state = milkmanStore.state

  getTimeRanges() {
      let timeRanges = []
      let hoursObj = this.getState();
      if (!hoursObj) return [];
      let pickedBy = _.pickBy(hoursObj, (val, key) => key.includes(":00"))
      for (let key in pickedBy) {
        let value = pickedBy[key]
        let valuePickedBy = _.pickBy(value,(val, key) => key.includes(":00") && val !== null)
        for (let x in valuePickedBy) {
          let z = valuePickedBy[x]
          timeRanges.push({
            from: key,
            to: x,
            price: z
          })
        }
      } 
      return timeRanges 
  }

  when() {
    return this.state.loaded != null
  }

  getState () {
    return this.state.hoursObj
  }

  loadBySubscription(zipCode, city) {
    this.state = {
      hoursObj: null,
      timeRanges: true,
      loaded: null
    };
    this.store.callMilkman(
      moment().add(1, 'weeks').startOf('isoWeek'), 
      moment().add(1, 'weeks').startOf('isoWeek').add(1, 'days'),
      this.state,
      zipCode,
      city
    ).then(i => {
    })
  }
}
